import { Modal } from 'bootstrap';
import { Artist } from 'shared/classes/Artist';
import { Invoice } from 'shared/classes/Billing';
import { SCEvent } from 'shared/classes/Event';
import { GLOBAL_CURRENCIES } from 'shared/common/constants';
import { CSVPrinter } from 'static/classes/CSVPrinter';
import { AdminPerson } from 'static/classes/Person';

export function AllInvoicesViewModel(data) {

    //console.log(data);

    var self = this;
    self.type = "AllInvoicesViewModel";

    self.rootvm = data.rootvm;
	self.csvprint = new CSVPrinter(data);

    self.initialized = ko.observable(false);
    self.initialize = function(){
        //console.log('initing all invoices vm');
        if (self.offset() == undefined){
            self.offset(0);
        }
        if (self.limit() == undefined){
            //console.log('setting limit');
            self.limit(100);
        }

        if (!self.initialized()){
            self.lookup_invoices();
        }
    };

    self.total_count = ko.observable();
    self.filtered_count = ko.observable();
    self.offset = ko.observable(0);
    self.limit = ko.observable(100);

    self.invoices= ko.observableArray([]);

    self.b_paid_count = ko.observable(data.b_paid_count);
    self.brutto_paid = ko.observable(data.brutto_paid);
    self.b_unpaid_count = ko.observable(data.b_unpaid_count);
    self.brutto_unpaid = ko.observable(data.brutto_unpaid);

    self.today_brutto = ko.observable(data.today_brutto);
    self.week_avg_brutto = ko.observable(data.week_avg_brutto);
    self.month_avg_brutto = ko.observable(data.month_avg_brutto);


    self.error = ko.observable();
    self.search_name = ko.observable();
    self.unpaid_only = ko.observable(false);
    self.payouts_without_payin = ko.observable(false);
    self.cancelled_only = ko.observable(false);
    self.filter_invoice_type = ko.observable();
    self.filter_event_type = ko.observable();

    self.invoice_types = ko.observableArray([{value:'fee', title:'F (Fee)'},
                    {value:'commission', title: 'C (Commission)'},
                    {value: 'flatcommission', title: 'CF (Flat Commission)'},
                    {value:'proartist', title:'PA (Pro Artist)'},
                    {value: 'gift', title: 'G (Gift)'}]);

    self.event_types = ko.observableArray([
                    {value:'sofaconcert', title:'sofaconcert'},
                    {value:'gys_song', title: 'gys_song'},
                    {value: 'wedding', title: 'wedding'},
                    {value:'other', title:'Other'},
                    {value:'birthday', title:'birthday'},
                    {value: 'corporate_event', title: 'corporate_event'}]);


    self.start_date = ko.observable();
    /*
    self.start_date.subscribe(function(newValue) {
        $('#enddate').datepicker('setStartDate', newValue);
    });
    */
    self.end_date = ko.observable();
    /*
    self.end_date.subscribe(function(newValue) {
        $('#startdate').datepicker('setEndDate', newValue);
    });
    */
    self.supported_currencies = ko.observableArray(GLOBAL_CURRENCIES);
    self.selected_currency = ko.observable();

    self.search_name_click = function(){
        self.offset(0);
        if(self.limit() == -1 || self.limit() == ""){
            self.limit(undefined);
        }

        if(self.end_date() == ''){
            self.end_date(undefined)
        }
        if(self.start_date() == ''){
            self.start_date(undefined)
        }

        console.log('searching with ', self.search_name());
        self.lookup_invoices();
        return false;
    }

    self.clear_click = function(){
        self.offset(0);
        self.limit(30);
        self.end_date(undefined);
        self.start_date(undefined);
        self.search_name(undefined);
        self.unpaid_only(false);
        self.payouts_without_payin(false);
        self.cancelled_only(false);

        return false;
    }

    self.set_sender_filter = (invoice)=>{
        self.search_name(invoice.sender_uuid());
        self.search_name_click();
    };

    self.set_receiver_filter = (invoice) => {
        self.search_name(invoice.receiver_uuid());
        self.search_name_click();
    }


    self.lookup_invoices = function(){
        self.rootvm.is_busy(true);

        console.log('limit is  ', self.limit());
        return $.ajax({

            url: self.rootvm.web_host + '/api/admin/invoices',
            type: 'GET',
            data:{
                limit: self.limit(),
                offset: self.offset(),
                search_name: self.search_name(),
                selected_invoice_type: self.filter_invoice_type(),
                selected_event_type: self.filter_event_type(),
                start_date: self.start_date(),
                end_date: self.end_date(),
                unpaid_only: self.unpaid_only(),
                payouts_without_payin: self.payouts_without_payin(),
                cancelled_only: self.cancelled_only(),
                selected_currency: self.selected_currency()
            },

            contentType: "application/json; charset=utf-8",

            success: function (data) {

                self.invoices(ko.utils.arrayMap( data.invoices || [],
                    function(x){
                        x.rootvm = self.rootvm
                        return new Invoice(x);
                    }));

                self.total_count(data.total_count);
                self.filtered_count(data.filtered_count);

                self.b_paid_count(data.b_paid_count);
                if(data.brutto_paid){
                    self.brutto_paid(data.brutto_paid.toLocaleString(  undefined, {minimumFractionDigits: 0,
                      maximumFractionDigits: 0}) + ' &euro;');
                }
                self.b_unpaid_count(data.b_unpaid_count);

                if(data.brutto_unpaid){
                    self.brutto_unpaid(data.brutto_unpaid.toLocaleString(  undefined, {minimumFractionDigits: 0,
                      maximumFractionDigits: 0}) + ' &euro;');
                }

                if(data.today_brutto){
                    self.today_brutto(data.today_brutto.toLocaleString(  undefined, {minimumFractionDigits: 0,
                      maximumFractionDigits: 0}) + ' &euro;');
                }

                if(data.week_avg_brutto){
                    self.week_avg_brutto(data.week_avg_brutto.toLocaleString(  undefined, {minimumFractionDigits: 0,
                      maximumFractionDigits: 0}) + ' &euro;');
                }

                if(data.month_avg_brutto){
                    self.month_avg_brutto(data.month_avg_brutto.toLocaleString(  undefined, {minimumFractionDigits: 0,
                      maximumFractionDigits: 0}) + ' &euro;');
                }




            },
            error: function (data) {
                notyf.error(data.statusText);
            },
            complete: function(){
                self.rootvm.is_busy(false);
            }
        });
    };


// needed?
/*
    self.lookup_upcoming_events = function(){
        return $.ajax({

            url: self.rootvm.web_host + '/api/events/upcoming',
            type: 'GET',
            data:{
                limit: 10,
            },

            contentType: "application/json; charset=utf-8",

            success: function (data) {

                self.upcoming_events(ko.utils.arrayMap( data.events || [],
                    function(x){

                        x.rootvm = self.rootvm
                        return new SCEvent(x);
                    }));
            },

            error: function (data) {
                self.error(data.statusText);
            }
        });
    };
*/
    // Everything below is for paging -- should really create a
    // component at some point

    self.lower_count_label = ko.computed(function(){
        return parseInt(self.offset()) + 1;
    });

    self.upper_count_label = ko.computed(function(){
        if (parseInt(self.limit()) + parseInt(self.offset()) > self.filtered_count())
        {
            return self.filtered_count();
        }
        else
        {
            return parseInt(self.limit()) + parseInt(self.offset());
        }
    });



    self.paging_visible = ko.computed(function () {
        return self.total_count() > 0;
    });

    self.next_button_visible = ko.computed(function() {
        return parseInt(self.offset()) + parseInt(self.limit()) < self.filtered_count();
    });

    self.previous_button_visible = ko.computed(function () {
        return parseInt(self.offset()) > 0;
    });



    self.go_left = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) - parseInt(self.limit()));

        self.lookup_invoices().then(function(){
            pager.navigate("#accounting/income-confirmed"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
            );
        });
    };

    self.go_right = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) + parseInt(self.limit()));
        self.lookup_invoices().then(function(){
            pager.navigate("#accounting/income-confirmed"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
            );
           });
    };



    // Edit Invoice
    self.selected_invoice = ko.observable();
    self.new_sender_name = ko.observable();
    self.new_sender_address = ko.observable();
    self.new_receiver_name = ko.observable();
    self.new_receiver_address = ko.observable();
    self.new_extra_line_invoice = ko.observable();
    self.new_due_date = ko.observable();

    // Marketing source of the host, shown when the Source icon is clicked.
    self.selected_acquisition_invoice = ko.observable();

    self.show_acquisition_details = function(invoice){
        self.selected_acquisition_invoice(invoice);
        const acquisitionModal = document.getElementById('acquisitionModal');
        Modal.getOrCreateInstance(acquisitionModal).show();
    };

    self.show_edit_details = function(invoice){
        self.new_sender_name(invoice.sender_name());
        self.new_sender_address(invoice.sender_address());
        self.new_receiver_name(invoice.receiver_name());
        self.new_receiver_address(invoice.receiver_address());
        self.new_extra_line_invoice(invoice.extra_line_invoice());
        self.new_due_date(invoice.due_date());
        self.selected_invoice(invoice);
        const changeInvoiceModal = document.getElementById('changeInvoiceModal');
        Modal.getOrCreateInstance(changeInvoiceModal).show();
    };

    self.save_invoice_details = function(){
        return $.ajax({
            url: "/api/admin/invoice/update-details",
            type: "POST",
            contentType: "application/json; charset=utf-8",
            processData: false,

            data: ko.toJSON({
                invoice_uuid:  self.selected_invoice().invoice_uuid(),
                receiver_name: self.new_receiver_name(),
                receiver_address: self.new_receiver_address(),
                sender_name: self.new_sender_name(),
                sender_address: self.new_sender_address(),
                extra_line_invoice: self.new_extra_line_invoice(),
                due_date: self.new_due_date(),
            }),

            complete: function (data) {
                self.rootvm.is_busy(false);
            },

            success: function (data) {
                if (data.success) {
                    self.selected_invoice().receiver_name(self.new_receiver_name());
                    self.selected_invoice().receiver_address(self.new_receiver_address());
                    self.selected_invoice().sender_name(self.new_sender_name());
                    self.selected_invoice().sender_address(self.new_sender_address());
                    self.selected_invoice().extra_line_invoice(self.new_extra_line_invoice());

                    self.selected_invoice().due_date(self.new_due_date());
                    self.selected_invoice().pdf_path(data.invoice.pdf_path + '?x=' + Date.now());

                    notyf.success(data.message);
                    const changeInvoiceModal = document.getElementById('changeInvoiceModal');
                    Modal.getInstance(changeInvoiceModal)?.hide();
                }
                else {
                    notyf.error(data.message);
                }
            },
            statusCode:{
                500 : function(){
                    notyf.error('Server error! Find Rob!')
                }
            }

       });
    }

    // Refund
    self.show_refund_modal = function(invoice){
        console.log("In SHow REFUND MODAL");
        self.selected_invoice(invoice);
        self.selected_invoice().refund_iban(undefined);
        self.selected_invoice().refund_bic(undefined);
        const invRefundMaster = document.getElementById('invRefundMaster');
        Modal.getOrCreateInstance(invRefundMaster).show();
    }


    self.show_auto_refund_modal = function(invoice){
        console.log("In SHow AUTO REFUND MODAL");
        self.selected_invoice(invoice);
        self.selected_invoice().refund_iban(undefined);
        self.selected_invoice().refund_bic(undefined);
        const invRefundAuto = document.getElementById('invRefundAuto');
        Modal.getOrCreateInstance(invRefundAuto).show();
    }

    self.show_partial_refund = function(invoice){
        console.log("In SHowp partial  REFUND CODE MODAL");
        self.selected_invoice(invoice);
        self.selected_invoice().refund_code_amount(invoice.brutto());
        const partialinvRefundCode = document.getElementById('partialInvRefundCode');
        Modal.getOrCreateInstance(partialinvRefundCode).show();
    }


    self.show_refund_code_modal = function(invoice){
        console.log("In SHow REFUND CODE MODAL");
        self.selected_invoice(invoice);
        self.selected_invoice().refund_code_amount(invoice.brutto());
        const invRefundCode = document.getElementById('invRefundCode');
        Modal.getOrCreateInstance(invRefundCode).show();
    }


    self.selected_artist_info = ko.observable(new Artist({}));
    self.set_selected_artist_info = function(artist){
        const modalArtistInfo = new Modal(
            document.getElementById('invoicesArtistInfo'))
        if (self.selected_artist_info().artist_uuid() === artist().artist_uuid()) {
            modalArtistInfo.show();
        } else {
            self.selected_artist_info().artist_uuid(artist().artist_uuid());
            self.selected_artist_info().lookup_details().then((artist) => {
                self.selected_artist_info(artist);
                modalArtistInfo.show();
            });
        }
    };

    // Selected Event Info
    self.selected_event_info = ko.observable(new SCEvent({}));

    self.set_selected_event_history = function(scevent){
        self.selected_event_info(scevent);
        self.selected_event_info().
            lookup_details(false).then(() => {
                const invEventInfoModal = document.getElementById('invEventInfoModal');
                Modal.getOrCreateInstance(invEventInfoModal).show();
        });
    };

    // Person Modal
    self.selected_person_info = ko.observable(new AdminPerson({}));
    self.set_selected_person_info = function(person_uuid, invoice_uuid){
        const modalPersonInfo = new Modal(document.getElementById('invoicesPersonInfo'))

        if (self.selected_person_info().person_uuid() === person_uuid) {
            modalPersonInfo.show();
        } else {
            self.selected_person_info().person_uuid(person_uuid);
            self.selected_person_info().lookupDetails().
                then((person) => {
                self.selected_person_info(person);
                modalPersonInfo.show();
            });
        }
    };

};
